import apiFetch from "../shared/services/apiClient";

export async function resetSystemData() {
  const res = await apiFetch("/api/admin/delete/", {
    method: "DELETE",
  });

  if (!res.ok) {
    throw new Error("Error al resetear datos");
  }

  return res.json();
}
